import { styled } from 'twin.macro';
import { Container as ContainerBase } from '../shared/Container/Container.styles';

export const Container = styled(ContainerBase)`
  margin-bottom: 2.5rem;
`;
